import { Lightning, Colors, Language } from "@lightningjs/sdk";
import theme from "../../../../lib/theme";

export const WELCOME_BOX_W = 260;
export const WELCOME_BOX_H = 238;
const PAD_Y = 107;
const PAD_X = 35;

interface WelcomeBoxSpec extends Lightning.Component.TemplateSpec {
    Background: object;
    Content: {
        Welcome: object;
        Name: object;
    };
}

export class WelcomeBox
    extends Lightning.Component<WelcomeBoxSpec>
    implements Lightning.Component.ImplementTemplateSpec<WelcomeBoxSpec>
{
    static override _template(): Lightning.Component.Template<WelcomeBoxSpec> {
        return {
            w: WELCOME_BOX_W,
            h: WELCOME_BOX_H,
            Background: {
                w: WELCOME_BOX_W,
                h: WELCOME_BOX_H,
                rect: true,
                color: Colors(theme.colors.bg.secondary).get(),
                shader: { type: Lightning.shaders.RoundedRectangle, radius: theme.channelItem.border.radius },
                transitions: { color: { duration: 0.2 } }
            },
            Content: {
                flex: { direction: "column" },
                x: PAD_X,
                y: PAD_Y,
                Welcome: {
                    text: {
                        text: Language.translate("welcome.title"),
                        fontSize: 20,
                        textColor: Colors(theme.colors.text.primary).alpha(0.7).get(),
                        maxLines: 1
                    }
                },
                Name: {
                    text: {
                        text: "Mr Sven",
                        fontSize: 30,
                        textColor: Colors(theme.colors.text.primary).get(),
                        maxLines: 1
                    }
                }
            }
        };
    }

    override _focus() {
        this.patch({
            Background: {
                smooth: { color: Colors(theme.colors.focus).get() }
            }
        });
    }

    override _unfocus() {
        this.patch({
            Background: {
                smooth: { color: Colors(theme.colors.bg.secondary).get() }
            }
        });
    }
}
